import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  clearSimpleFormValidations(event) {
    event.target.closest(".form-group").querySelector(":scope > .help-block")?.remove()
  }
}
